export const USERS_SUBSCRIPTION_UPDATE_REQUEST = 'users/subscription-update-request'
export const USERS_SUBSCRIPTION_UPDATE_SUCCESS = 'users/subscription-update-success'
export const USERS_SUBSCRIPTION_UPDATE_FAILED = 'users/subscription-update-failed'
